import StatusIcon from '@/components/ui/icons/StatusIcon'
import { formatDateTime } from '@/lib/utils'
import { borderRadius, colors, fontSizes, fontWeights } from '@/theme'
import { Box, Chip, Typography } from '@mui/material'
import type { Stage } from './types'

interface StageCardProps {
  stage: Stage
  itemWidth: number
  isLast: boolean
}

export default function StageCard({ stage, itemWidth, isLast }: StageCardProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        flex: '0 0 auto',
        width: itemWidth || 120,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {!isLast && (
        <Box
          sx={{ position: 'absolute', top: 20, left: '50%', right: '-50%', height: 2, bgcolor: colors.border.default }}
        />
      )}

      <Box sx={{ zIndex: 1 }}>
        <StatusIcon status={stage.status as 'current' | 'complete'} />
      </Box>

      <Box
        sx={{
          width: '75%',
          border: `1px solid ${colors.border.default}`,
          borderRadius: borderRadius.sm,
          p: 1.5,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.75
        }}
      >
        <Typography sx={{ fontSize: fontSizes.xs, fontWeight: fontWeights.semibold }}>{stage.label}</Typography>
        <Typography variant='smallText'>{formatDateTime(stage.date)}</Typography>
        <Chip label={stage.type} size='small' />
      </Box>
    </Box>
  )
}
